<template>
    <apexo-button-group class="text-gray-600">
        <pagination-button
            class="w-10"
            :disabled="currentPage == 1"
            :primary="false"
            @click="goTo(1)"
        >
            &#60;&#60;
        </pagination-button>
        <pagination-button
            class="w-10"
            :disabled="currentPage == 1"
            :primary="false"
            @click="goTo(currentPage - 1)"
        >
            &#60;
        </pagination-button>
        <pagination-button
            class="w-11"
            :primary="page == currentPage ? true : false"
            :key="page"
            @click="goTo(page)"
            v-for="page in visiblePages"
        >
            {{ page }}
        </pagination-button>
        <pagination-button
            class="w-10"
            :disabled="currentPage == lastPage"
            :primary="false"
            @click="goTo(currentPage + 1)"
        >
            &#62;
        </pagination-button>
        <pagination-button
            class="w-10"
            :disabled="currentPage == lastPage"
            :primary="false"
            @click="goTo(lastPage)"
        >
            &#62;&#62;
        </pagination-button>
    </apexo-button-group>
</template>

<script>
    import range from 'lodash/range.js';
    import PaginationButton from '@/components/PaginationButton.vue';
    import ApexoButtonGroup from '@/components/Elements/ApexoButtonGroup.vue';

    export default {
        components: {
            PaginationButton,
            ApexoButtonGroup,
        },

        props: {
            currentPage: {
                type: Number,
                required: true,
            },
            lastPage: {
                type: Number,
                required: true,
            },
        },

        computed: {
            visiblePages() {
                const pages = range(1, this.lastPage + 1);

                return pages.filter(page => {
                    if (this.currentPage == 1) {
                        return page <= this.currentPage + 2;
                    } if (this.currentPage == this.lastPage) {
                        return page >= this.currentPage - 2;
                    }

                    return page <= this.currentPage + 1 && page >= this.currentPage - 1;
                });
            },
        },

        methods: {
            goTo(page) {
                if (
                    page < 1 ||
                    page > this.lastPage ||
                    (this.currentPage == 1 && page == 1) ||
                    (this.currentPage == this.lastPage && page == this.lastPage)
                ) {
                    return;
                }

                this.$emit('update', page);
            },
        },
    };
</script>
